import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=4dc86b7f&scoped=true"
import script from "./CompanyModal.vue?vue&type=script&lang=js"
export * from "./CompanyModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyModal.vue?vue&type=style&index=0&id=4dc86b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc86b7f",
  null
  
)

export default component.exports